import React, { FC, useCallback } from 'react';

import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { ICartEntryType } from 'state/loyalty/in-restaurant-redemption';

import RewardRedemptionIncrementor from './reward-redemption-incrementor';
import { Badge, BadgeWrapper, Container } from './styled';
import { BadgeAndIncrementorProps } from './types';

enum IncrementorActions {
  Increment = 'increment',
  Decrement = 'decrement',
}

const BadgeAndIncrementor: FC<React.PropsWithChildren<BadgeAndIncrementorProps>> = ({
  cartEntry,
  handleUpdateEntry,
}) => {
  const enableRewardUnstacking = useFlag(LaunchDarklyFlag.ENABLE_REWARD_UNSTACKING);
  const isDetailsReward = cartEntry.type === ICartEntryType.REWARD;

  const handleChangeQuantity = useCallback(
    (value: number) => {
      handleUpdateEntry(
        cartEntry,
        { quantity: value },
        value < cartEntry.quantity ? IncrementorActions.Decrement : IncrementorActions.Increment
      );
    },
    [handleUpdateEntry, cartEntry]
  );

  const badgeKey = isDetailsReward ? 'reward' : 'offer';
  const badgeText = t(badgeKey);

  return (
    <Container>
      <BadgeWrapper testID="badge" $orange={isDetailsReward}>
        <Badge>{badgeText}</Badge>
      </BadgeWrapper>

      {cartEntry.type === ICartEntryType.REWARD && !enableRewardUnstacking && (
        <RewardRedemptionIncrementor
          quantity={cartEntry.quantity}
          details={cartEntry.details}
          onChange={handleChangeQuantity}
        />
      )}
    </Container>
  );
};

export default BadgeAndIncrementor;
